import { GoabIcon, GoabSpacer, GoabText } from '@abgov/angular-components';
import { Component } from '@angular/core';

@Component({
  selector: 'app-smoking-policy',
  imports: [GoabText, GoabIcon, GoabSpacer],
  templateUrl: './smoking-policy.html',
  styleUrl: './smoking-policy.scss',
})
export class SmokingPolicy {}
